import { Link } from "react-router-dom";
import { Truck, MapPin, ArrowRight } from "lucide-react";
import { TRAILER_SCHEDULE } from "../lib/trailerSchedule";

// Compact "find the trailer" strip for the home page. Data comes from the
// same weekly schedule as the Events page section.
const TrailerStrip = () => {
  const data = TRAILER_SCHEDULE;
  if (!data?.active || !data.stops?.length) return null;

  return (
    <section data-testid="trailer-strip" className="max-w-5xl mx-auto px-6 lg:px-10 pt-2 pb-8">
      <Link
        to="/events"
        data-testid="trailer-strip-link"
        className="group block rounded-2xl overflow-hidden border border-[#00b4ff]/40 bg-gradient-to-br from-[#0a0a10] to-[#051018] hover:border-[#00b4ff]/80 hover:shadow-[0_0_28px_rgba(0,180,255,0.25)] transition-all"
      >
        <div className="h-[2px] bg-gradient-to-r from-[#00b4ff] via-[#ff1a8c] to-[#00b4ff]" />
        <div className="p-5 sm:p-6 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
          <div className="flex items-center gap-3 shrink-0">
            <span className="w-10 h-10 rounded-full bg-[#00b4ff]/15 text-[#00b4ff] flex items-center justify-center">
              <Truck className="w-5 h-5" />
            </span>
            <div>
              <p className="text-[9px] uppercase tracking-[0.28em] text-[#00b4ff]">This week</p>
              <p className="font-script text-2xl text-white leading-none">Find the trailer</p>
            </div>
          </div>

          <ul className="flex flex-wrap gap-x-5 gap-y-2 flex-1">
            {data.stops.map((stop) => (
              <li
                key={`${stop.day}-${stop.name}`}
                data-testid={`trailer-strip-stop-${stop.day.toLowerCase()}`}
                className="flex items-center gap-1.5 text-xs text-gray-300"
              >
                <span className="text-[#ff1a8c] font-semibold uppercase tracking-[0.14em] text-[10px]">{stop.day.slice(0, 3)}</span>
                <MapPin className="w-3 h-3 text-[#00b4ff]" />
                {stop.name}
              </li>
            ))}
          </ul>

          <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[#ff1a8c] font-semibold shrink-0">
            Details <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </section>
  );
};

export default TrailerStrip;
